import { render, staticRenderFns } from "./RichInputToolbarDropdown.vue?vue&type=template&id=4d04afe6&"
import script from "./RichInputToolbarDropdown.vue?vue&type=script&lang=js&"
export * from "./RichInputToolbarDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports